/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useParams } from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Accordion from "../Accordion";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import SubSubject from "./SubSubject";
import Button from "../../components/Button";
import SkillToImprove from "./SkillToImprove";
import Spacer from "../../utils/spacer";
import ActionCheckpoint from "./ActionCheckpoint";
import { useTranslation } from "react-i18next";
import getUserIP, { formatIPJSON } from "../../utils/getUserIP";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#fff",
    color: "#646464",
  },
}));

export default function EditSubjectsTabs({ campaignData, ...props }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();
  const { addNotification } = useNotification();
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [subjectList, setSubjectList] = useState(null);
  const [subjectDataForSave, setSubjectDataForSave] = useState([]);
  const [dataType, setDataType] = useState(null);
  const [conditionToPassList, setConditionToPassList] = useState(null);
  const [frameworkList, setFrameworkList] = useState(null);
  const [userIP, setUserIP] = useState(null);

  const saveApiData = {
    campaign_id: id,
    functional_unit: campaignData.department,
    subject_for: props.subjectFor,
    status: props.status,
    user_id: props.userId,
    user_role: props.userRole,
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getDataType();
    getConditionToPass();
    getFrameworkList();
    getUserIP().then(res => setUserIP(formatIPJSON(res)));
  }, []);

  useEffect(() => {
    getSubjectList();
  }, [props.subjectFor]);

  async function getSubjectList() {
    setIsLoading(true);

    const response = await apiRequest.get(
      `/api/getSubjectsByCamapingID?campaign_id=${id}&subject_for=${
        props.subjectFor ? props.subjectFor : 1
      } `
    );

    if (response.status === 200) {
      let data = response.data.data;

      setSubjectList(data);
      setSubjectDataForSave(data);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  async function getDataType() {
    const response = await apiRequest.get(`/api/getDataType`);

    if (response.status === 200) {
      let data = response.data.data;
      if (data.length > 0) {
        data = data.map(item => {
          return {
            value: item.text.toLowerCase(),
            label: item.text,
            ...item,
          };
        });

        setDataType(data);
      }
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  async function getConditionToPass() {
    const response = await apiRequest.get(`/api/getConditionToPass`);

    if (response.status === 200) {
      let data = response.data.data;
      if (data.length > 0) {
        data = data.map(item => {
          return {
            value: item.value,
            label: item.text,
            ...item,
          };
        });

        setConditionToPassList(data);
      }
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  async function getFrameworkList() {
    const response = await apiRequest.get(`/api/getFramework`);

    if (response.status === 200) {
      let data = response.data.data;
      if (data.length > 0) {
        data = data.map(item => {
          return {
            value: item.id,
            label: item.text,
            ...item,
          };
        });

        setFrameworkList(data);
      }
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  const handleSubjectChange = (obj, subIndex, index) => {
    if (subjectDataForSave.length > 0) {
      let currentObj = [...subjectDataForSave];
      currentObj[index].sub_category = obj;
      setSubjectDataForSave(currentObj);
    }
  };

  const handleDeleteSubcategory = (deleteID, index) => {
    const arrayList = [].concat(deleteID);
    let data = [...subjectDataForSave];
    data[index].deleteSubjectCategoryId = data[index].deleteSubjectCategoryId
      ? data[index].deleteSubjectCategoryId.concat(arrayList)
      : arrayList;
    setSubjectDataForSave(data);
  };

  const handleDeleteSkillImprovement = (deleteIDs, index) => {
    const arrayList = [].concat(deleteIDs);
    let data = [...subjectDataForSave];
    data[index].deleteSubjectResultSkillId = data[index]
      .deleteSubjectResultSkillId
      ? data[index].deleteSubjectResultSkillId.concat(arrayList)
      : arrayList;
    setSubjectDataForSave(data);
  };

  const handleSkillChange = (obj, index) => {
    if (subjectDataForSave.length > 0) {
      let currentObj = [...subjectDataForSave];
      currentObj[index].skills_to_improve = obj;
      setSubjectDataForSave(currentObj);
    }
  };

  const saveSubjectDetails = () => {
    setIsLoading(true);
    let formData = {
      ...saveApiData,
      data: subjectDataForSave,
      userIP: userIP,
    };

    apiRequest
      .post(`/api/storeSubjectDetails`, formData)
      .then(resp => {
        console.log("Api response", resp);
        if (resp.status === 200 && resp.data.data.status) {
          const data = resp.data.data;

          addNotification(t("subjectManagement.subjectDetails"), "success");
          setIsLoading(false);
          getSubjectList();
        } else {
          const errMsg = resp.data.data.message;
          if (errMsg && errMsg !== "") {
            addNotification(t(`${errMsg}`), "error");
          } else {
            addNotification(t("error.internalServerError"), "error");
          }

          setIsLoading(false);
        }
      })
      .catch(error => {
        addNotification(`${error}`, "error");
        setIsLoading(false);
      })
      .finally(() => {});
  };

  return (
    <div className={classes.root}>
      <Tabs value={value} onChange={handleChange}>
        <Tab
          label={t("subjectManagement.coachingCategory")}
          {...a11yProps(0)}
        />
        <Tab
          label={t("subjectManagement.actionAtCheckpoint")}
          {...a11yProps(1)}
        />
      </Tabs>

      <TabPanel value={value} index={0}>
        <>
        {console.log(subjectList,'subject')}
          {subjectList &&
            subjectList.map((subject, index) => (
              <Accordion
                key={index}
                summary={subject.type + " - " + subject.subject}
                titleColor="#222736"
                details={
                  <div style={{ width: "100%" }}>
                    {dataType && conditionToPassList && frameworkList && (
                      <SubSubject
                        subjectIndex={index}
                        handleChange={(currentObj, subIndex) => {
                          handleSubjectChange(currentObj, subIndex, index);
                        }}
                        data={subject.sub_category}
                        dataType={dataType}
                        conditionToPassList={conditionToPassList}
                        frameworkList={frameworkList}
                        onDelete={id => {
                          handleDeleteSubcategory(id, index);
                        }}
                        sessionType={subject.type}
                      />
                    )}
                     {frameworkList.some(item => item.type === subject.type && item.value === 1) && (
            <>
              <SkillToImprove
                      data={subject.skills_to_improve}
                      handleChange={currentObj => {
                        handleSkillChange(currentObj, index);
                      }}
                      onDelete={ids => {
                        handleDeleteSkillImprovement(ids, index);
                      }}
                    />      
            </>
          )}
                  </div>
                }
              />
            ))}
          <Spacer y={6} />
          <div>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={saveSubjectDetails}
              isloading={isLoading ? 1 : 0}
            >
              {t("subjectManagement.saveChanges")}
            </Button>
          </div>
          <div>
            <Button
              variant="outlined"
              fullWidth
              style={{ marginTop: "10px", border: "none", color: "#757575" }}
              onClick={() => {
                history.push("/settings/subjectManagement/");
              }}
            >
              {t("subjectManagement.cancel")}
            </Button>
          </div>
        </>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ActionCheckpoint
          campaignId={id}
          userId={props.userId}
          saveData={saveApiData}
        />
      </TabPanel>
    </div>
  );
}